import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { jsx as _jsx } from "react/jsx-runtime";
const alert = ({
  type,
  title,
  message,
  options
}) => {
  FloatingAlertStore.addAlert(Object.assign({
    type,
    message,
    titleText: title
  }, options));
};
export const genericAlertSuccess = ({
  title = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "bulkActions.alerts.titles.success"
  }),
  message,
  options
}) => alert({
  type: 'success',
  title,
  message,
  options: Object.assign({
    'data-test-id': 'bulk-actions-bet-alert-success'
  }, options)
});
export const genericAlertFailure = ({
  title = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "bulkActions.alerts.titles.failure"
  }),
  message,
  options
}) => alert({
  type: 'danger',
  title,
  message,
  options
});
export const genericAlertWarning = ({
  title = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "bulkActions.alerts.titles.warning"
  }),
  message,
  options
}) => alert({
  type: 'warning',
  title,
  message,
  options
});
export const alertBulkActionSuccess = ({
  count,
  langkey
}) => {
  genericAlertSuccess({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langkey || 'bulkActions.alerts.success',
      options: {
        count
      }
    })
  });
};
export const alertBulkActionFailure = ({
  count,
  langkey
}) => {
  genericAlertFailure({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langkey || 'bulkActions.alerts.failure',
      options: {
        count
      }
    })
  });
};
export const alertBulkActionCreateTasksSuccess = ({
  count,
  link
}) => {
  genericAlertSuccess({
    message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "bulkActions.alerts.tasks.createTasks.success",
      options: {
        count,
        link
      }
    }),
    options: {
      'data-test-id': 'bulk-create-tasks-success'
    }
  });
};